module.exports = __webpack_public_path__ + "img/headerR.d57ee6f5.png";